module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_15.ccb5fc5b.jpg";